import { Grid as GridComponent } from '@giphy/react-components'
import styled from 'styled-components'

export const Grid = styled(GridComponent)`
    margin: 0 auto;
    overflow: hidden;
    padding: 15px 0 30px;
    position: relative;

    img {
        background: transparent !important;
        cursor: pointer;
    }
`
